<template>
    <div class="app-footer">
        <div class="container">
            <div class="footer-main">
                <ul class="nav-list">
                    <li class="nav-item" v-for="(nav,index) in navList" :key="index">
                        <div class="nav-title">
                            <router-link :to="nav.url">{{$t(nav.key)}}</router-link>
                        </div>
                        <ul class="sub-nav-list" v-if="nav.items && nav.items.length>0">
                            <li class="sub-nav-item" v-for="(item,subIndex) in nav.items" :key="subIndex" @click="navClick(item)">
                                <a :href="item.link" target="_blank" v-if="item.link">{{$t(item.key)}}</a>
                                <router-link :to="item.url" v-else>{{$t(item.key)}}</router-link>
                            </li>
                        </ul>
                    </li>
                    <li class="nav-item">
                        <div class="nav-title">{{$t(others.key)}}</div>
                        <div class="icon-list">
                            <a class="icon-item">
                                <img src="../../assets/icon/wx.png" class="icon">
                                <img :src="qrCodePicUrl" class="code-img" alt="qr-code">
                            </a>
                            <a class="icon-item" :href="'tel:'+telephone">
                                <Tooltip :content="telephone" theme="light">
                                    <img src="../../assets/icon/phone.png" class="icon">
                                </Tooltip>

                            </a>
                        </div>
                        <!--<div class="item" style="margin-bottom: 20px;">-->
                        <!--<span>{{$t('common.tel')}}：</span>-->
                        <!--<a href="tel:021-68949998">021-68949998</a>-->
                        <!--</div>-->
                        <!--<div class="item">-->
                        <!--<img src="../../assets/img/footer/wxcode.jpg" alt="">-->
                        <!--</div>-->
                    </li>
                </ul>
            </div>
            <div class="copyright">©2022 <a  target="_blank" href="https://beian.miit.gov.cn">浙ICP备2022028436号</a> {{$t('common.copyright')}}</div>
        </div>
    </div>
</template>

<script>
    import data from './config'

    export default {
        data() {
            return {
                navList: data.navList,
                others: data.others,
                qrCodePicUrl:'',
                telephone:'',
            }
        },
        created(){
            this.$api.home.getFooterData().then(res=>{
                this.telephone = res.telephone;
                this.qrCodePicUrl = this.$imgHost + res.qrCodePicUrl;
            })
        },
        methods:{
            navClick(item){
                // if (item.url == '') {
                //     this.$Message.info('正在建设中');
                // }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .app-footer {
        height: $footer-height;
        margin-top: -$footer-height;
        background-image: url("../../assets/img/footer/bg.jpg");
        background-size: cover;
        background-position: center;

    }

    .nav-list {
        padding-top: 50px;
        padding-bottom: 15px;

        display: flex;
        justify-content: space-around;
        .nav-item {

            .nav-title {
                margin-bottom: 34px;
                letter-spacing: 1.25px;
                font-weight: 500;
                color: #fff;
                font-size: $font-size-large;

                a {
                    letter-spacing: 1.25px;
                    font-weight: 500;
                    color: #fff;
                    font-size: $font-size-large;
                }
            }

            .item {
                color: #fff;
                opacity: 0.8;

                a {
                    color: #fff;
                    opacity: 0.8;
                }
            }
        }
    }

    .sub-nav-list {
        .sub-nav-item {
            margin-bottom: 10px;

            a {
                opacity: 0.8;
                color: #fff;
                transition: all 0.5s;

                &:hover {
                    opacity: 1;
                }
            }
        }
    }

    .icon-list {
        .icon-item {
            display: inline-block;
            margin-right: 10px;
            position: relative;

            &:last-child {
                margin-right: 0;
            }

            &:hover {
                .code-img {
                    opacity: 1;
                }
            }

            i {
                color: #fff;
                font-size: 40px;
            }

            .code-img {
                position: absolute;
                width: 120px;
                bottom: -130px;
                left: 0;
                opacity: 0;
                transition: all 0.5s;
            }
        }
    }

    .copyright {
        text-align: center;
        opacity: 0.8;
        color: #999;
        a{
            color:inherit;
            &:hover{
                color:#2D8cF0;
            }
        }
    }
</style>